import { ZodiacTaurusIcon } from './ZodiacTaurusIcon';

/**
 * author: Michael Richins
 * id 40205151-C976-49D8-98F1-A0E120086E07
 * name zodiac-taurus
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-taurus.svg
 * tags
 */
export const HoroscopeTaurusIcon = ZodiacTaurusIcon;
export default HoroscopeTaurusIcon